import { useSelector } from 'src/store';
import { selectors } from 'src/store/navbar';

export const useCuisineFilterButtonDesktopState = () => useSelector(selectors.selectInlineFilterButtonsDockedDesktop);
export const useCuisineFilterButtonTabletState = () => useSelector(selectors.selectInlineFilterButtonsDockedTablet);
export const useCuisineFilterButtonMobileState = () => useSelector(selectors.selectInlineFilterButtonsDockedMobile);

export const useCuisineFilterButtonState = () => useSelector(selectors.selectCuisineFilterButton);

export const useCuisineFilterButtonDockedStates = () => ({
  isDockedOnDesktop: useCuisineFilterButtonDesktopState(),
  isDockedOnTablet: useCuisineFilterButtonTabletState(),
  isDockedOnMobile: useCuisineFilterButtonMobileState(),
  isShowing: useCuisineFilterButtonState(),
});
